import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { LucideAngularModule, Upload, AlertCircle } from 'lucide-angular';

export interface ArticlePublishConfirmModalData {
  articlesCount: number;
  targetEnvironment: string; // 'QA' o 'PROD'
  currentEnvironment: string; // 'Borrador', 'QA', 'Producción'
  articleIdentifiers?: string[]; // Identificadores de los artículos a publicar
}

@Component({
  selector: 'app-article-publish-confirm-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    LucideAngularModule
],
  templateUrl: './article-publish-confirm-modal.component.html',
  styleUrls: ['./article-publish-confirm-modal.component.scss']
})
export class ArticlePublishConfirmModalComponent {
  readonly Upload = Upload;
  readonly AlertCircle = AlertCircle;

  constructor(
    public dialogRef: MatDialogRef<ArticlePublishConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ArticlePublishConfirmModalData
  ) {}

  /**
   * Determina el texto del ambiente destino basado en el ambiente actual
   */
  getTargetEnvironmentLabel(): string {
    return this.data.targetEnvironment;
  }

  /**
   * Genera el mensaje principal del modal
   */
  getMessage(): string {
    const articleText = this.data.articlesCount === 1 ? 'el artículo' : `${this.data.articlesCount} artículos`;
    const targetEnv = this.getTargetEnvironmentLabel();
    return `¿Está seguro que desea publicar ${articleText} a ${targetEnv}?`;
  }

  /**
   * Genera el mensaje de advertencia adicional
   */
  getWarningMessage(): string {
    if (this.data.targetEnvironment === 'Producción') {
      return 'Esta acción publicará los artículos en el ambiente de Producción y estarán disponibles para todos los usuarios.';
    }
    return 'Esta acción publicará los artículos en el ambiente de QA para realizar pruebas.';
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  /**
   * Verifica si hay identificadores para mostrar
   */
  hasIdentifiers(): boolean {
    return !!this.data.articleIdentifiers && this.data.articleIdentifiers.length > 0;
  }

  /**
   * Determina si se debe mostrar la lista completa o una lista acortada con scroll
   */
  shouldShowScrollableList(): boolean {
    return this.hasIdentifiers() && this.data.articleIdentifiers!.length > 5;
  }
}